export default __webpack_public_path__ + "static/media/cardano-ada-logo.a4b8cb52.png";